import { IRulesAction, IRulesState } from './rules.types'
import { RulesConstants } from './rules.constants'

export const initialRulesState: IRulesState = {
  errors: {},
  groupedRulesErrors: {},
  dispatchedActions: [],
  isLoading: false,
}

export function rulesReducer(state: IRulesState = initialRulesState, action: IRulesAction): IRulesState {
  switch (action.type) {
    case RulesConstants.SET_RULES_ERRORS:
      return { ...state, errors: action.errors }
    case RulesConstants.SET_GROUPED_RULES_ERRORS:
      return { ...state, groupedRulesErrors: action.groupedRulesErrors }
    case RulesConstants.SET_DISPATCHED_ACTIONS:
      return { ...state, dispatchedActions: action.dispatchedActions }
    case RulesConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case RulesConstants.RESET_RULES_STATE:
      return {
        errors: {},
        groupedRulesErrors: {},
        dispatchedActions: [],
        isLoading: false,
      }
    default:
      return state
  }
}
